import React, { useEffect } from 'react';
import styles from 'assets/css/CourseComponent.module.css';
import ScheduleCoursePartials from 'Components/Card/Partials/Partials.ScheduleCourse';
import scheduleCourseHelpers from 'Components/Card/helper/scheduleCourseHelpers';
import useAttention from 'context/AttentionContext';
import { getUTCDateFromServerDate } from 'utils/dateUtils';
import CoursePartials from 'Components/Card/Partials/Partials.Course';
import classNames from 'classnames';
import CardHeader from "../CardHeader";

/*
[Display States]:
1) not scheduled
2) scheduled
3) [possibly?] audit
4) completed
*/

/*
[Required Props]
Shared
- HeaderText
- SubHeaderText
- HasCourse --> scheduled : not scheduled
- HasUpcomingClass

State: Not Scheduled
- "Schedule Now Display"
- VoucherExpirationDate
- Schedule Now Button

State: Scheduled
- EventDateTime
- EventEnd
- EventOrganizerDisplay
- Event Button (open course, launch class)

State: Completed
- "Completed Date Display"
- Open Course Btn
*/

function ScheduleCourseSubComponent(props) {
    const { course } = props;
    const { 
        showVoucher, 
        showEvent, 
        showAudit, 
        showComplete,
        showIncomplete
    } = scheduleCourseHelpers.getShowProperties(course);
    const { clearAttentionState, setAttentionWarning } = useAttention();

    useEffect(() => {
        if (showVoucher || showAudit) {
            setAttentionWarning();
        } else {
            clearAttentionState();
        }
    }, [showVoucher, showAudit, setAttentionWarning, clearAttentionState]);

    const classes = classNames(styles.contentWrap, {
        [styles['bg-blue-dark']]: !course.HasCourse
    });

    return (
        <div className={classes}>
            <CardHeader cardTools={props.cardToolsSubheader}  cardTitle={course.HeaderText} hideCollapse={true} />
            <h4 className={styles.courseSubtitle}>{course.SubHeaderText}</h4>
            {showVoucher && <ScheduleCoursePartials.VoucherContent voucherExpirationDate={getUTCDateFromServerDate(course.VoucherExpirationDate)} />}
            {showEvent && <ScheduleCoursePartials.ScheduleCourseEventDisplay {...props}><ScheduleCoursePartials.CourseLaunchBtn {...props} /></ScheduleCoursePartials.ScheduleCourseEventDisplay>}
            {showAudit && <ScheduleCoursePartials.AuditContent />}
            {<CoursePartials.BodyCopy bodyStateCopy={course.BodyStateCopy} />}
            {showComplete && <ScheduleCoursePartials.CompleteContent completionDate={getUTCDateFromServerDate(course.CompletionDate)} />}
            {!course.HasUpcomingClass && <ScheduleCoursePartials.CardLink {...course} />}
        </div>
    )
}

export default ScheduleCourseSubComponent;